import Http from "../../http/client";

export default async ({
                          name,
                          commercial,
                          foundedYear,
                          taxNumber,
                          ibanName,
                          iban,
                          email,
                          invoiceAddress,
                          commission
                      }, id) => {
    const response = await Http.patch('admin/driver/company/' + id, {
        name,
        commercial,
        foundedYear,
        taxNumber,
        ibanName,
        iban,
        email,
        invoiceAddress,
        commission
    });
    return response.data;
}
